import { render, staticRenderFns } from "./PreviewImage.vue?vue&type=template&id=10ca5524&scoped=true&"
import script from "./PreviewImage.vue?vue&type=script&lang=js&"
export * from "./PreviewImage.vue?vue&type=script&lang=js&"
import style0 from "./PreviewImage.vue?vue&type=style&index=0&id=10ca5524&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ca5524",
  null
  
)

export default component.exports